export const CATEGORY_HIGHLIGHTS='highlights'
